import * as React from "react";
import type { SVGProps } from "react";
const SvgIntegrations = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <g clipPath="url(#integrations_svg__a)">
      <path
        fill="#90B9FF"
        d="M19.853 3.5H3.615a.6.6 0 0 0-.435.186.65.65 0 0 0-.18.449v16.93c0 .168.065.33.18.449.116.119.272.186.435.186h6.25a.6.6 0 0 0 .332-.101.63.63 0 0 0 .227-.27.65.65 0 0 0-.095-.68l-.038-.045a2.04 2.04 0 0 1-.456-1.292c0-1.096.852-1.986 1.9-1.986 1.046 0 1.898.888 1.898 1.986 0 .485-.169.953-.478 1.318a.653.653 0 0 0-.115.692.63.63 0 0 0 .232.278.6.6 0 0 0 .342.1h6.239c.163 0 .32-.067.435-.186.115-.12.18-.28.18-.449v-4.254c0-.154.133-.274.287-.274 1.79 0 3.245-1.515 3.245-3.377s-1.456-3.376-3.245-3.376a.28.28 0 0 1-.287-.275V4.135a.65.65 0 0 0-.18-.45.6.6 0 0 0-.435-.185"
        opacity={0.6}
      />
      <path
        fill="#23F6E7"
        d="M5.647 20.2h16.238c.163 0 .32-.067.435-.186a.65.65 0 0 0 .18-.449V2.635a.65.65 0 0 0-.18-.449.6.6 0 0 0-.435-.186h-6.25a.6.6 0 0 0-.332.101.63.63 0 0 0-.227.27c-.05.112-.066.235-.05.355.018.121.068.234.146.326l.037.044c.295.362.457.82.456 1.292 0 1.095-.852 1.986-1.9 1.986-1.046 0-1.898-.888-1.898-1.986 0-.485.169-.953.478-1.318a.653.653 0 0 0 .115-.692.63.63 0 0 0-.232-.278.6.6 0 0 0-.342-.1H5.647a.6.6 0 0 0-.435.186.65.65 0 0 0-.18.449v4.541a3 3 0 0 0-.287-.013c-1.79 0-3.245 1.515-3.245 3.377s1.456 3.376 3.245 3.376q.144 0 .287-.013v5.662c0 .168.065.33.18.449.115.12.272.186.435.186"
      />
    </g>
    <defs>
      <clipPath id="integrations_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIntegrations;
